<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="aggregate-result">
    <component :is="hasWebPage ? 'a' : 'div'"
               :href="url"
               class="aggregate-result__image-wrapper">
      <picture>
        <source :srcset="mobileSrcSet"
                media="(max-width: 991px)">
        <source :srcset="srcSet"
                media="(min-width: 992px)">
        <img :src="src"
             :alt="computedAltText"
             class="aggregate-result__image"
             role="presentation">
      </picture>
    </component>

    <div class="aggregate-result__content">
      <component :is="hasWebPage ? 'a' : 'div'"
                 :href="url"
                 class="aggregate-result__heading-wrapper">
        <h3 class="aggregate-result__heading">
          {{ name }}
        </h3>
      </component>

      <div v-if="formattedCategories"
           class="aggregate-result__category">
        {{ formattedCategories }}
      </div>

      <p class="aggregate-result__description"
         v-html="computedDescription">
      </p>

      <div class="aggregate-result__actions">
        <a v-if="hasWebPage"
           :href="url"
           :rel="hasWebPage ? 'nofollow' : ''"
           class="btn btn-accent-8 btn-sm">
          Read more
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AggregateSearchResult",
  props: {
    url: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ""
    },
    thumbnailUrl: {
      type: String,
      default: "/Assets/images/no-icon.png"
    },
    thumbnailAltText: {
      type: String,
      default: undefined
    },
    hasWebPage: {
      type: Boolean,
      default: false
    },
    categories: {
      type: Array,
      default: null
    }
  },
  computed: {
    formattedCategories () {
      let result = "";

      if ( this.categories && Array.isArray( this.categories ) ) {
        result = this.categories.join( ", " );
      }

      return result;
    },
    computedDescription () {
      let result = this.description;

      if ( !result ) {
        result = "No description available.";
      }

      const chopLength = 180;
      if ( result.length > chopLength ) {
        result = `${result.substring( 0, chopLength - 3 )}...`;
      }

      return result;
    },
    computedAltText () {
      let result = this.thumbnailAltText;

      if ( !result ) {
        result = `Thumbnail for ${this.name}`;
      }

      return result;
    },
    mobileSrcSet () {
      return `${this.generateUrl( 600 )} 1x, ${this.generateUrl( 1200 )} 2x`;
    },
    src () {
      return this.generateUrl( 160 );
    },
    srcSet () {
      return `${this.generateUrl( 160 )} 1x, ${this.generateUrl( 320 )} 2x`;
    }
  },
  methods: {
    generateUrl ( width ) {
      let result = `/Assets/images/no-icon.png?width=${width}`;

      if ( this.thumbnailUrl ) {
        if ( !this.thumbnailUrl.startsWith( "/" ) ) {
          result = `/remote.axd?${this.thumbnailUrl}?width=${width}`;
        } else {
          result = `${this.thumbnailUrl}?width=${width}`;
        }
      }

      return `${encodeURI( result )}`;
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../Styles/utils/colors.less";

.aggregate-result {
  padding: 15px;
  border: 4px solid @color-accent-8;
  background: #fff;
  display: flex;
  flex-direction: column;
  width: 100%;

  &__image-wrapper {
    width: 100%;
    flex-shrink: 0;
    margin-bottom: 15px;

    @media ( max-width: 767px ) {
      width: 100%;
      max-height: none;
      margin-bottom: 10px;
      margin-right: 0;
    }
  }

  &__image {
    aspect-ratio: 16 / 9;
    min-height: 120px;
    width: 100%;
    object-fit: contain;
  }

  &__content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex-basis: 100%;
  }

  &__heading-wrapper {
    width: 100%;
  }

  &__heading {
    font-size: 1.25rem;
    margin-bottom: 10px;
    width: 100%;
    color: #008385;
  }

  &__category {
    font-weight: 600;
  }

  &__description {
    font-size: 14px;
    flex-grow: 1;
    width: 100%;
  }

  &__actions {
    display: flex;
    font-size: 14px;
  }

  .btn {
    padding: 3px 10px;
  }

  .btn-add-to-basket {
    margin-left: 5px;
    background: none;
    border: 0;
    color: @color-accent-8;
  }

  @media ( max-width: 991px ) {
    flex-direction: column;
  }
}
</style>
